import { push } from 'connected-react-router'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import type { Dispatch } from 'redux'
import { fetchProfileData } from 'shared/store/ecommerce/catalog'
import type { OrderInfos } from 'shared/store/ecommerce/order'
import {
    getPaymentUrl,
    oneClickPayment,
    priceSelector,
    sendCurrentOrder,
    waitForOrderStatusChange
} from 'shared/store/ecommerce/order'
import { updateProfile } from 'shared/store/kingdom/profile'
import type { ECommerceMetadata, EventMetadata } from 'shared/store/metadata'
import {
    eCommerceMetadata,
    eventMetadata,
    pageMetadata
} from 'shared/store/metadata'
import type { RootState } from 'shared/store/reducers'
import type { MetaShortDTO, ProfileUserForm } from 'shared/types'
import { featureCodes, orderPickUpType, restaurantServices } from 'shared/utils'
import { getCurrentOrder } from 'shared/utils/ecommerce'
import { CartUserInfosComponent } from './CartUserInfosComponent'

const { PARKING } = orderPickUpType

const mapStateToProps = (rootState: RootState, ownProps) => {
    const {
        ecommerceOrderState,
        kingdomProfilePageState,
        userState,
        router,
        featuresState
    } = rootState
    const { finalPrice } = priceSelector(rootState)
    const { collectMode, products, restaurant, adyen } = ecommerceOrderState
    const { available } = featuresState
    const { search } = router.location
    const neptingStatus = search.split('status=')[1]

    return {
        ...userState,
        ...kingdomProfilePageState,
        finalPrice,
        products,
        adyen,
        restaurant,
        pickUpParking: collectMode === PARKING,
        mealVoucherService:
            !!restaurant &&
            restaurant.services.includes(restaurantServices.MEAL_VOUCHER),
        isPaymentWithoutLoginEnabled: available.includes(
            featureCodes.WORKFLOW_ORDER_NOT_CONNECTED
        ),
        neptingStatus,
        manageError: ownProps.manageError,
        setError: ownProps.setError,
        clearError: ownProps.clearError,
        handleAdyenPayment: ownProps.handleAdyenPayment,
        isLoading: ownProps.isLoading,
        setIsLoading: ownProps.setIsLoading,
        availableFeatures: available,
        currentOrder: getCurrentOrder(
            ecommerceOrderState.cacOrders,
            ecommerceOrderState.deliveryOrders,
            ecommerceOrderState.currentToken
        ),
        storedCards: ownProps.storedCards,
        cardIdSelected: ownProps.cardIdSelected
    }
}

const mapDispatchToProps = (d: Dispatch<any>) => ({
    fetchProfileData: () => d(fetchProfileData()),
    updateProfile: (form: ProfileUserForm) => d(updateProfile(form)),
    sendCurrentOrder: (data: OrderInfos) => d(sendCurrentOrder(data)),
    sendECommerceMeta: (meta: ECommerceMetadata) => d(eCommerceMetadata(meta)),
    pageMetadata: (payload: MetaShortDTO) => d(pageMetadata(payload)),
    waitForOrderStatusChange: () => d(waitForOrderStatusChange()),
    oneClickPayment: (cbid: string) => d(oneClickPayment(cbid)),
    getPaymentUrl: (selectedCardId?: string, cardEnrolment: boolean) =>
        d(getPaymentUrl(selectedCardId, cardEnrolment)),
    sendMeta: (meta: EventMetadata) => d(eventMetadata(meta)),
    navigate: (to: string, state?: any) =>
        d(
            push({
                pathname: to,
                state
            })
        )
})

export const CartUserInfos = connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(CartUserInfosComponent))
